export default __webpack_public_path__ + "static/media/il.d92f72de.svg";